<div nz-row>
    <div nz-col nzSpan="6">
      <span class="pageTitle">Pending Query Request</span>
    </div>
    <div nz-col nzSpan="8">
      <div class="search-container">
        <nz-input-group [nzPrefix]="searchIcon">
          <input nz-input type="text" placeholder="Enter minimum 3 characters to search..." [(ngModel)]="searchText"
            class="search-box" (input)="onSearch()" />
        </nz-input-group>
        <ng-template #searchIcon>
          <i nz-icon nzType="search"></i>
        </ng-template>
      </div>
    </div>
    
  </div>

  <nz-table #pendingQueryTable [nzScroll]="{ x: '2300px' }" [nzData]="filteredQueryRequest" [nzBordered]="true"
    [nzSize]="'small'" [nzShowPagination]="true">
    <thead>
      <tr>
        <th *ngFor="let column of pendingTableColumns" [nzSortFn]="column.compare" [nzSortPriority]="column.priority"
          [nzShowSort]="column.showShort" style="padding: 1px 10px; font-size: 11px; font-weight: 100;width: 150px;">
          {{ column.title }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let query of pendingQueryTable.data">
        <td *ngIf="currentUser.IsRFCAdmin" class="text-center">
          <button nz-button nzType="primary" [nzSize]="'small'" *ngIf="(query.QueryStatusCode == queryAnsweredByDeptEnum || 
                            query.QueryStatusCode == queryAnsweredBySponsorEnum)"
            routerLink="/clarification-query/recycle-query/{{query.QueryCode}}"
            value="Recycle" title="Recycle" >Recycle</button>
          <button nz-button nzType="primary" [nzSize]="'small'" *ngIf="(query.QueryStatusCode != queryResponseEnum 
                              && query.QueryStatusCode != queryDeleteByAdminEnum
                              && query.QueryStatusCode != queryDeleteByPartnerEnum)"
             value="Delete" (click)="showDeleteConfirm(query)" style="margin-left: 2px;" title="Delete">Delete</button>
        </td>
        <td class="text-center"><a class="referanceNumber" style="cursor: pointer; font-size: 11px; " routerLink="/clarification-query/view-query/{{query.QueryCode}}">
            <strong>{{query.QueryRequestNumber}}</strong></a>
        </td>
        <td class="text-center">{{query.Subject}}</td>
        <td class="text-center" style="width: 15px;"><strong>{{query.QueryStatus}}</strong>
          <div *ngIf="(query.QueryStatusCode == queryAssgnToDepRepEnum || query.QueryStatusCode == queryRecycledEnum)">
            <small *ngFor="let name of query.QueryAssignedTo?.split('|')">
              {{ name }}
            </small>
          </div>
          <div
            *ngIf="(query.QueryStatusCode == queryAnsweredByDeptEnum || query.QueryStatusCode == queryAnsweredBySponsorEnum)">
            <small *ngFor="let name of query.QueryAnsBy?.split('|')">
              {{ name }}
            </small>
          </div>
        </td>
        <td>{{query.RequestorName}}</td>
        <td>{{query.RequestedDate | date:'dd-MMM-yyyy' }}</td>
        <td>{{query.Category}}</td>
        <td>{{query.SubCategory}}</td>
        <td>{{query.Block}}</td>
        <td>{{query.PriorityLevel}}</td>
        <td>{{query.Confidential}}</td>
        <td>{{query.Department}}</td>
        <td>{{query.SubDeptartment}}</td>
        <td>{{query.RespondedDate | date:'dd-MMM-yyyy hh:mm:ss a' }}</td>
        <td>{{query.CreatedByUserName}}</td>
        <td style="font-size: 12px;">{{query.QueryReqDueDate | date:'dd-MMM-yyyy hh:mm:ss a'}}</td>
      </tr>
    </tbody>
  </nz-table>


  